import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ICatalogLayout } from '../order-catalog.service';
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';

@Component({
  selector: 'catalog-layout-selector-field',
  template: `
    <div class="radio catalog-item-list-layout">
      <label *ngFor="let layout of possibleLayouts; trackBy: trackByFunction">
        <i class="fa {{layout.icon}}" [ngClass]="{active: layout.name === selectedLayout.name}" title="{{layout.title}}" (click)="onSelectLayout.emit(layout)"></i>
        <span class="visually-hidden">{{layout.name}}</span>
      </label>
    </div>
	`,
  styleUrls: ['catalog-layout-selector-field.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CatalogLayoutSelectorFieldComponent {
  @Input() public possibleLayouts:ICatalogLayout[];
  @Input() public selectedLayout:ICatalogLayout;
  @Output() public onSelectLayout:EventEmitter<ICatalogLayout> = new EventEmitter();

  public trackByFunction:Function = trackByFunction;
}